import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './bank-account.reducer';

export const BankAccountDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bankAccountEntity = useAppSelector(state => state.bankAccount.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bankAccountDetailsHeading">
          <Translate contentKey="crawlerBackendApp.bankAccount.detail.title">BankAccount</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{bankAccountEntity.id}</dd>
          <dt>
            <span id="bankAccountNumber">
              <Translate contentKey="crawlerBackendApp.bankAccount.bankAccountNumber">Bank Account Number</Translate>
            </span>
          </dt>
          <dd>{bankAccountEntity.bankAccountNumber}</dd>
          <dt>
            <span id="bankAccountHolder">
              <Translate contentKey="crawlerBackendApp.bankAccount.bankAccountHolder">Bank Account Holder</Translate>
            </span>
          </dt>
          <dd>{bankAccountEntity.bankAccountHolder}</dd>
          <dt>
            <span id="paymentMethod">
              <Translate contentKey="crawlerBackendApp.bankAccount.paymentMethod">Payment Method</Translate>
            </span>
          </dt>
          <dd>{bankAccountEntity.paymentMethod}</dd>
          <dt>
            <span id="billingPeriod">
              <Translate contentKey="crawlerBackendApp.bankAccount.billingPeriod">Billing Period</Translate>
            </span>
          </dt>
          <dd>{bankAccountEntity.billingPeriod}</dd>
          <dt>
            <span id="currency">
              <Translate contentKey="crawlerBackendApp.bankAccount.currency">Currency</Translate>
            </span>
          </dt>
          <dd>{bankAccountEntity.currency}</dd>
        </dl>
        <Button tag={Link} to="/bank-account" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/bank-account/${bankAccountEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BankAccountDetail;
